export const initialFilterValues = {
  requestType: undefined,
  status: undefined,
  ialn: undefined,
  startDate: undefined,
  endDate: undefined,
  premiumDiscountIndicator: undefined,
  fraudDetectionIndicator: undefined,
  masterPoolNumber: undefined
};

export const DEFAULT_NUMBERS_OF_ITEMS_PER_PAGE = 100;
